<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Employee Injury Reports'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Injury Date/Time'"
                            [binding]="'injuryDateTime'"
                            [format]="'g'"
                            [width]="170"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'jobDisplay'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Injured Employee'"
                            [binding]="'injuredEmployeeHrRef'"
                            [dataMap]="employeeMap"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Location'"
                            [binding]="'location'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Work Status'"
                            [binding]="'workStatusDisplay'"
                            [width]="180"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
